import React from 'react'
import { styled } from '@mui/material/styles'
import { AppBar, Box, IconButton, Toolbar, Typography } from '@mui/material'
import { useLocation, Link, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import i18next from 'i18next'
import { useTheme } from '@emotion/react'
import StoreIcon from '@mui/icons-material/Store'
import { useStore } from '../../../context/StoreProvider'
import { getProductNavLabel, getProductsShowMethod } from '../../../utils/storeDisplaySettings'

// الأيقونات المخصصة
import { ReactComponent as HomeBar } from './../../../assets/icons/HomeBar.svg'
import { ReactComponent as PhoneBar } from './../../../assets/icons/PhoneBar.svg'
import { ReactComponent as MneuBar } from './../../../assets/icons/MneuBar.svg'
import { ReactComponent as LinksBar } from './../../../assets/icons/LinksBar.svg'
import { ReactComponent as OffersBar } from './../../../assets/icons/OffersBar.svg'
// import { ReactComponent as Map } from './../../../assets/icons/map-2-fill24px.svg'

const makeStyledIcon = (IconComponent) =>
    styled(IconComponent, {
        shouldForwardProp: (prop) => prop !== 'active',
    })(({ theme, active }) => ({
        '& svg': {
            width: 24,
            height: 20
        },
        '& path': {
            fill: active ? theme.palette.nav.btn : 'gray',
            width: 24,
            height: 20
        },
    }))

const HomeIcon = makeStyledIcon(HomeBar)
const PhoneIcon = makeStyledIcon(PhoneBar)
// const MapIcon = makeStyledIcon(Map)
const MenuIcon = makeStyledIcon(MneuBar)
const LinksIcon = makeStyledIcon(LinksBar)
const OffersIcon = makeStyledIcon(OffersBar)

const BottomNav = () => {
    const { slug } = useParams()
    const { t } = useTranslation()
    const theme = useTheme()
    const location = useLocation()
    const lng = i18next.language
    const { storeData } = useStore() || {}
    const productsShowMethod = getProductsShowMethod(storeData, slug)

    const type = localStorage.getItem(`type-${slug}`)
    const package_type = localStorage.getItem(`package_type-${slug}`)
    const has_private_package = localStorage.getItem(`has_private_package-${slug}`) === 'true'

    const isActive = (path) => location.pathname === path

    return (
        <AppBar
            position="sticky"
            elevation={0}
            sx={{
                backgroundColor: theme.palette.nav.main,
                boxShadow: '0 -2px 4px rgba(0, 0, 0, 0.1)',
                bottom: 0,
                zIndex: 999,
            }}
        >
            <Toolbar disableGutters>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-evenly',
                        width: '100%',
                    }}
                >
                    {/* الرئيسية */}
                    <Link to={`/${slug}`} style={{ textDecoration: 'none' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 1 }}>
                            <IconButton sx={{ p: 0 }}>
                                <HomeIcon active={isActive(`/${slug}`)} />
                            </IconButton>
                            <Typography
                                variant="subtitle2"
                                sx={{
                                    color: isActive(`/${slug}`) ? theme.palette.nav.btn : 'gray',
                                    fontFamily: 'URW DIN Arabic',
                                    fontWeight: 'medium',
                                    fontSize: 14
                                }}
                            >
                                {t('visitor.home')}
                            </Typography>
                        </Box>
                    </Link>

                    {/* التواصل */}
                    {!has_private_package && (
                        <Link to={`/${slug}/contact`} style={{ textDecoration: 'none' }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 1 }}>
                                <IconButton sx={{ p: 0 }}>
                                    {<PhoneIcon active={isActive(`/${slug}/contact`)} />}
                                </IconButton>
                                <Typography
                                    variant="subtitle2"
                                    sx={{
                                        color: isActive(`/${slug}/contact`) ? theme.palette.nav.btn : 'gray',
                                        fontFamily: 'URW DIN Arabic',
                                        fontWeight: 'medium',
                                        fontSize: 14
                                    }}
                                >
                                    {package_type === 'multi_branch' && type !== 'mall'
                                        ? (lng === 'ar' ? 'التواصل' : 'Communication')
                                        : t('visitor.contact')
                                    }
                                </Typography>
                            </Box>
                        </Link>
                    )}

                    {/* محلات أو قائمة */}
                    {type === 'mall' ? (
                        <Link to={`/${slug}/shops`} style={{ textDecoration: 'none' }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 1 }}>
                                <IconButton sx={{ p: 0, color: isActive(`/${slug}/shops`) ? theme.palette.nav.btn : 'gray' }}>
                                    <StoreIcon />
                                </IconButton>
                                <Typography
                                    variant="subtitle2"
                                    sx={{
                                        color: isActive(`/${slug}/shops`) ? theme.palette.nav.btn : 'gray',
                                        fontFamily: 'URW DIN Arabic',
                                        fontWeight: 'medium',
                                        fontSize: 14
                                    }}
                                >
                                    {lng === 'en' ? 'Stores' : 'المتاجر'}
                                </Typography>
                            </Box>
                        </Link>
                    ) : (
                        <Link to={`/${slug}/menu`} style={{ textDecoration: 'none' }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 1 }}>
                                <IconButton sx={{ p: 0 }}>
                                    <MenuIcon active={isActive(`/${slug}/menu`)} />
                                </IconButton>
                                <Typography
                                    variant="subtitle2"
                                    sx={{
                                        color: isActive(`/${slug}/menu`) ? theme.palette.nav.btn : 'gray',
                                        fontFamily: 'URW DIN Arabic',
                                        fontWeight: 'medium',
                                        fontSize: 14
                                    }}
                                >
                                    {getProductNavLabel(productsShowMethod, t, lng)}
                                </Typography>
                            </Box>
                        </Link>
                    )}

                    {/* الروابط */}
                    {!has_private_package && (
                        <Link to={`/${slug}/links`} style={{ textDecoration: 'none' }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 1 }}>
                                <IconButton sx={{ p: 0 }}>
                                    <LinksIcon active={isActive(`/${slug}/links`)} />
                                </IconButton>
                                <Typography
                                    variant="subtitle2"
                                    sx={{
                                        color: isActive(`/${slug}/links`) ? theme.palette.nav.btn : 'gray',
                                        fontFamily: 'URW DIN Arabic',
                                        fontWeight: 'medium',
                                        fontSize: 14
                                    }}
                                >
                                    {t('visitor.links')}
                                </Typography>
                            </Box>
                        </Link>
                    )}

                    {/* العروض */}
                    <Link to={`/${slug}/offers`} style={{ textDecoration: 'none' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 1 }}>
                            <IconButton sx={{ p: 0 }}>
                                <OffersIcon active={isActive(`/${slug}/offers`)} />
                            </IconButton>
                            <Typography
                                variant="subtitle2"
                                sx={{
                                    color: isActive(`/${slug}/offers`) ? theme.palette.nav.btn : 'gray',
                                    fontFamily: 'URW DIN Arabic',
                                    fontWeight: 'medium',
                                    fontSize: 14
                                }}
                            >
                                {t('visitor.offers')}
                            </Typography>
                        </Box>
                    </Link>
                </Box>
            </Toolbar>
        </AppBar>
    )
}

export default BottomNav
